import React, { useEffect } from 'react';
import { Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { Formik, Form, Field } from 'formik';
import { useMutation } from '@apollo/client'
import * as Sentry from "@sentry/react";

import { INSERT_POST_ONE } from '../../gql/forum'
import { Input } from '../../helpers/formik';

const Post: React.FC<{ presentation_id: string }> = ({ presentation_id }) => {
    const intl = useIntl();

    const [insertPost, { loading, error }] = useMutation(INSERT_POST_ONE);

    useEffect(() => {
        if(error) {
            // TODO
            alert(error);
            //Sentry.captureException(error);
        }
    }, [error]);

    return <Formik
        onSubmit={async (values, { resetForm }) => {
            await insertPost({
                variables: {
                    object: { presentation_id, post: values.post }
                }
            })
            resetForm();
        }}
        initialValues={{
            post: ''
        }}
    >
        {() => (
            <Form className="forum-post-form" style={{     position: "absolute",  bottom: "15px", width: "90%" }} >
                <Field
                    name="post"
                    type="textarea"
                    component={Input}
                    placeholder={intl.formatMessage({ id: "forum.add.comment" })}
                    required
                />
                <Button className="btn-fo-common" color="primary" size="sm" disabled={loading}>
                    <FormattedMessage id="btn.submit" />{" "}
                </Button>
            </Form>
        )}
    </Formik>
}

export default Post;
